import { broadcastScheduleQueryKeys } from '@/features/broadcast-schedule/api/query-keys';
import { queryClient } from '@/lib/react-query';

/**
 * Refreshes what the client holds of an emission whose window the server has just
 * moved, after a block was added to or removed from one of its edges.
 *
 * RISK: the segment list shares this key prefix and lives in local state; refetching it races the animations.
 */
export function invalidateProgramBroadcastWindow(id: string) {
  queryClient.invalidateQueries({ queryKey: broadcastScheduleQueryKeys.id(id), exact: true });
  // `useProgramBroadcasts` takes the project's default `staleTime: Infinity`, so the
  // emission lists keep the old window until the tab is reloaded. Nothing in the review
  // view holds that key, so this only marks them stale. The schedule grid is not one of
  // them: it keys on `broadcastSchedule()` and sets `staleTime: 0`.
  queryClient.invalidateQueries({ queryKey: broadcastScheduleQueryKeys.lists() });
}
